import { render } from "./ProsthesisView.vue?vue&type=template&id=507f3fd4&scoped=true"
import script from "./ProsthesisView.vue?vue&type=script&lang=js"
export * from "./ProsthesisView.vue?vue&type=script&lang=js"

import "./ProsthesisView.vue?vue&type=style&index=0&id=507f3fd4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507f3fd4"]])

export default __exports__